const ReCAPTCHAPolicy = () => {
    return (
        <small style={{ fontSize: '100%' }}>
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" style={{ color: '#2196f3' }}>
                {' '}
                Privacy Policy
            </a>{' '}
            and
            <a href="https://policies.google.com/terms" style={{ color: '#2196f3' }}>
                {' '}
                Terms of Service
            </a>{' '}
            apply.
        </small>
    );
};

export default ReCAPTCHAPolicy;
